import { ReportLayout } from '../../../components/Report';

export function Reports() {
  return <ReportLayout />;
}
